package org.example.abigail

/**
 * Calcula la fecha del dia siguiente a partir de una fecha en formato "YYYY-MM-DD".
 */
fun calcularFechaManana(fechaHoy: String): String {
    return try {
        val partes = fechaHoy.split("-")
        val anio = partes[0].toInt()
        val mes = partes[1].toInt()
        val dia = partes[2].toInt()
        val diasEnMes = when (mes) {
            1, 3, 5, 7, 8, 10, 12 -> 31
            4, 6, 9, 11 -> 30
            2 -> if (anio % 4 == 0 && (anio % 100 != 0 || anio % 400 == 0)) 29 else 28
            else -> 30
        }
        if (dia < diasEnMes) "$anio-${mes.toString().padStart(2, '0')}-${(dia + 1).toString().padStart(2, '0')}"
        else if (mes < 12) "$anio-${(mes + 1).toString().padStart(2, '0')}-01"
        else "${anio + 1}-01-01"
    } catch (e: Exception) { fechaHoy }
}
